import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';


@Injectable({
  providedIn: 'root'
})
export class OfertasService {

  private TO_TAG = environment.apiUrl + '/totag/';
  private TO_VOTE = environment.apiUrl+ '/answer/';
  private TO_SETTLE = environment.apiUrl + '/tosettle/';
  private SETTLE = environment.apiUrl + '/settle/';



  constructor(private httpClient: HttpClient) {
  }

  public sendGetRequest(): Promise<any> {
    return this.httpClient.get(this.TO_TAG).toPromise();
  }

  votar(data: any) {
    return this.httpClient.post(this.TO_VOTE,data );
  }
}
